import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";
import { RoundHistoryRepository } from "../round-history.repository";

@Injectable({
    providedIn: "root"
})
export class GetRoundHistoryUseCase implements IUseCase<void, Observable<number[]>> {
    constructor(private roundHistoryRepository: RoundHistoryRepository) {
    }

    execute(): Observable<number[]> {
        return this.roundHistoryRepository.get();
    }
}
